var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 66,
    viewBox: "0 0 87 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.0508 48.6715L64.8559 35.0808V49.8027L42.0508 63.016V48.6715Z",
    stroke: "white",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9832 35.1207L39.051 48.6589V62.9774L16.9832 49.8153V35.1207Z",
    stroke: "white",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.48 1.76488L78.251 25.1399L65.138 33.2527L65.133 33.2558L40.4808 48.3746L15.9687 33.2558L15.9669 33.2547L2.84702 25.1376L40.48 1.76488Z",
    stroke: "white",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4243 56.7712C80.8484 56.7712 80.2725 56.3308 80.2725 55.5968V25.9422H40.9653C40.3894 25.9422 39.8135 25.5017 39.8135 24.7677C39.8135 24.1805 40.2454 23.5933 40.9653 23.5933H81.4243C82.0003 23.5933 82.5762 24.0337 82.5762 24.7677V55.5968C82.5762 56.3308 82.1442 56.7712 81.4243 56.7712Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1017 65.6186C77.9257 65.6186 75.2034 63.0665 75.2034 60.089C75.2034 56.9697 77.7744 54.5593 81.1017 54.5593C84.4289 54.5593 87 56.9697 87 60.089C87 63.0665 84.4289 65.6186 81.1017 65.6186ZM81.1017 56.6861C79.1356 56.6861 77.6232 58.104 77.6232 59.9472C77.6232 61.7904 79.1356 63.2083 81.1017 63.2083C83.0678 63.2083 84.5802 61.7904 84.5802 59.9472C84.7314 58.2458 83.0678 56.6861 81.1017 56.6861Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHat);
export default __webpack_public_path__ + "static/media/hat.9e0b036dcf137b41f211bbca02825f9e.svg";
export { ForwardRef as ReactComponent };